export default __webpack_public_path__ + "static/media/virtual-machines-tab.c96913c4.png";